<template>
    <section class="hero is-fullheight white-bg">
        <div class="hero-body">
            <div class="container has-text-centered">
                <div class="column is-4 is-offset-4">

                    <div id="login_block">
                        <!-- <logoSight /> -->
                        <h3 class="login_title title has-text-grey">Merci de patienter quelques instants</h3>
                    </div>

                </div>
            </div>
        </div>

    </section>
</template>

<script>
import LogoSight from '@/components/layouts/logoSight'
export default {
    name: 'Oauth',
    components: {
        LogoSight
    },
    mounted(){
        const code = this.$route.query.code
        const email = this.$route.query.email
        this.isLoading = true
        this.$store.dispatch('UserStore/login', { email: email, password: code })
        .then((res) => {
            if(res && res.status == 200){
                this.$router.push('/')
            }else{
                this.showErrorNotif = true
            }
            this.isLoading = false
        })
    },
    data(){
      return {
        isLoading: false
      }
    },
    computed: {

    },
    methods: {

    }
}

</script>

<style lang="scss">
#login_block{
    margin-bottom: 150px;
    .login_title {
        font-size: 3rem;
        text-transform: uppercase;
        color: $grey-light!important;
        margin-bottom: 80px;
    }
}
.notification.login_notif{
    width: 750px!important;
    left: calc(50% - 375px)!important;
}
.white-bg{
    background: white;
}

</style>
